// The pre-launch wall (app/views/shared/_beta_modal.html.erb). The partial
// only renders while DISABLE_NEW_PLANS is set, so the dialog being in the page
// *is* the flag — a gated button calls openBetaGate() first and returns when
// it answers true:
//
//   if (openBetaGate()) return
//
// The server refuses the same requests regardless, so this is the explanation
// rather than the enforcement.
let dismissWired = false

export function openBetaGate(): boolean {
  const dialog = document.querySelector<HTMLDialogElement>("[data-beta-modal]")
  if (!dialog) return false

  wireDismiss(dialog)
  if (!dialog.open) dialog.showModal()
  return true
}

// A POST that got past the hidden button comes back with the page rendered
// this way, so the refusal is visible instead of silent.
export function mountBetaModal(): void {
  const dialog = document.querySelector<HTMLDialogElement>("[data-beta-modal]")
  if (!dialog) return

  wireDismiss(dialog)
  if ("betaModalOpenOnLoad" in dialog.dataset) dialog.showModal()
}

// Close buttons, plus click-outside: the dialog fills the viewport, so a click
// that lands on it rather than the panel inside is the backdrop.
function wireDismiss(dialog: HTMLDialogElement): void {
  if (dismissWired) return
  dismissWired = true

  dialog.querySelectorAll<HTMLElement>("[data-beta-modal-close]").forEach((button) => {
    button.addEventListener("click", () => dialog.close())
  })
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close()
  })
}
